import { Theme } from "@mui/material"

export const ParticipantScreenStyles = (theme: Theme) => {
    return {
    signatureText: { fontSize: "19px", width: "100%" },

      emailSentText: {
        color: "#646464",
        textAlign: "center",
        fontSize: "10px",
      },
      privacyPolicyLink: {
        color: theme.palette.secondary.main,
        // display: "flex",
        // justifyContent: "center",
        // textAlign: "center",
        fontSize: "10px",
      },
      signHere: {
        color: theme.palette.signer.danger.main, // "red" fails 1.4.3 on field fills
        whiteSpace: "nowrap",

      },
      nameField: {
        fontSize: "0.875rem",
        color: "#646464",
        marginLeft: "5px",
        marginBottom: 1,
        "& .MuiFormLabel-asterisk": {
          color: theme.palette.primary.main,
        },
      },
      horizontalLine: {
        width: "-webkit-fill-available",
        border: `0.5px solid black`,
        height: " fit-content",
      },
      dropzoneMain: {
        display: "flex",
    justifyContent: "center",
    alignItems: "center",
        width: "100%",
        height: "100%",
        // padding: 10,
        [theme.breakpoints.down("sm")]: {
          padding: 0,
        },
      },
    }
}